module.exports = __webpack_public_path__ + "static/media/apparaturenimabzug.b99fc0bf.jpg";